import React from 'react';
import Logo from '../../../assets/images/logo.svg';

export const MenuLogo = () => (
  <span className='toolbar__logo'>
    <img src={Logo} alt='Exelot' height='40' />
  </span>
);
